<template>
    <div>
        <template v-for="file in value">
<!--            <a :href="file.full_url" target="_blank">-->
<!--                <app-icon name="external-link"/>-->
<!--            </a>-->
            <a :href="file.full_url" target="_blank">
                <app-icon v-if="file.full_url.endsWith('.pdf')" name="external-link"/>
                <img
                    v-else
                    :src="file.full_url"
                    alt="Attachment Preview"
                    class="attachment-preview"
                    :style="{ width: '50px', height: '50px', objectFit: 'cover' }"
                />
            </a>
        </template>
        <div v-if="value.length === 0">
            {{ '-' }}
        </div>
    </div>
</template>

<script>

export default {
    name: "AttachmentsColumn",
    props: {
        value: {},
        rowData: {}
    },
}
</script>
